import { render, staticRenderFns } from "./pai_tab.vue?vue&type=template&id=38f17a6f&scoped=true&"
import script from "./pai_tab.vue?vue&type=script&lang=js&"
export * from "./pai_tab.vue?vue&type=script&lang=js&"
import style0 from "./pai_tab.vue?vue&type=style&index=0&id=38f17a6f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f17a6f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38f17a6f')) {
      api.createRecord('38f17a6f', component.options)
    } else {
      api.reload('38f17a6f', component.options)
    }
    module.hot.accept("./pai_tab.vue?vue&type=template&id=38f17a6f&scoped=true&", function () {
      api.rerender('38f17a6f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_imc/memorandum/inside/body/addon/land/tabs/pai_tab.vue"
export default component.exports